import type { CSSProperties } from 'react';

import { Brand } from '@/lib/configuration/configuration';
import { BRAND } from '@/lib/const';
import { theme } from '@/theme/getTheme';

import type { HeadingProps } from './Heading';

import * as S from './Heading.styles';

type HeaderType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | null;

export const FormatHeading = (props: HeadingProps) => {
  const heading = props?.Heading;
  const text = heading?.text ?? '';
  const headingType = heading?.headingType ?? 'h1';

  const headingHighlightColor = heading?.highlightColor ?? theme.colors.heading;
  const headingAlignment =
    heading?.textAlignment ?? (BRAND === Brand.Gallet ? 'left' : 'center');

  const highlightedText = text.split(/\[\[|\]\]/).map((part, index) => {
    // The portion of the odd index is what needs to be highlighted
    const isHighlighted = index % 2 === 1;

    return part.split('<br>').map((line, lineIndex, arr) => {
      const elements = [
        <S.Title
          key={`${line}-${index}-${lineIndex}`}
          $isHighlight={isHighlighted}
          data-testid={`FormatHeadingTitle-${index}-${lineIndex}`}
          headingHighlightColor={headingHighlightColor}
          headingType={headingType}
          headingVariation={heading?.headingVariation as string}
          sizeDesktop={props.sizeDesktop}
          sizeMobile={props.sizeMobile}
        >
          {line}
        </S.Title>,
      ];

      if (lineIndex < arr.length - 1) {
        elements.push(<br key={`br-${line}-${index}-${lineIndex}`} />);
      }

      return elements;
    });
  });

  return (
    <S.FormatHeadingBox
      $color={heading?.mainColor ?? theme.colors.secondary}
      $headingSeoTag={(props.Heading?.headingSeoTag as HeaderType) ?? 'h2'}
      $headingType={headingType}
      $mobileTextAlign={props.mobileTextAlign ?? 'center'}
      as={(props.Heading?.headingSeoTag as HeaderType) ?? 'h2'}
      data-test-id='FormatHeadingBox'
      textAlign={headingAlignment}
    >
      {highlightedText}
    </S.FormatHeadingBox>
  );
};

export const renderContentfulHeadingSection = (props: HeadingProps) => {
  if (props.Heading) {
    const heading = props.Heading;
    const headingType = heading?.headingType ?? 'h1';
    if (heading.text) {
      return (
        <S.Heading
          $color={props.color ?? theme.colors.secondary}
          $isUppercase={BRAND !== Brand.Gallet}
          data-test-id='renderContentfulHeadingSectionHeading'
          headingType={headingType}
          isHeroSlider={props.isHeroSlider ?? undefined}
          shouldApplyBottomPadding={props.shouldApplyBottomPadding}
          textAlign={heading.textAlignment as CSSProperties['textAlign']}
        >
          <FormatHeading
            {...props}
            data-test-id='renderContentfulHeadingSectionFormatHeading'
          ></FormatHeading>
        </S.Heading>
      );
    }
  } else {
    return <></>;
  }
};
